module.exports = __webpack_public_path__ + "img/main_tips_small.12404814.png";